import React, { useState } from "react";
import moment from "moment";
import { getGameReportAPI } from "../../service/AuthService";
import { getReportPage } from "./ReportHelpers";

export default function GameReport() {
  const [fromDate, setFromDate] = useState(moment().subtract(7, "days").format("YYYY-MM-DD"));
  const [toDate, setToDate] = useState(moment().format("YYYY-MM-DD"));
  const [type, setType] = useState("ALL");
  const [event, setEvent] = useState("ALL");
  const [events, setEvents] = useState([]);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const requestReport = async (mode) => {
    setLoading(true);
    const result = await getGameReportAPI({
      startDate: new Date(`${fromDate}T00:00:00`),
      endDate: new Date(`${toDate}T23:59:59`),
      type,
      eventId: event === "ALL" ? null : event,
      mode,
    });
    const report = getReportPage(result?.response);
    if (mode === "GAME_LIST") setEvents(report.rows);
    else setRows(report.rows);
    setLoading(false);
  };

  return (
    <div className="main standard-report-page">
      <div className="container-fluid"><div className="row"><div className="col-md-12 main-container">
        <div className="listing-grid">
          <div className="detail-row">
            <h2>Game Report</h2>
            <div className="report-filter-form"><div className="row">
              <div className="col-md-2 form-group"><label htmlFor="game-report-from">From</label><input id="game-report-from" type="date" className="form-control" value={fromDate} max={toDate} onChange={(e) => setFromDate(e.target.value)} /></div>
              <div className="col-md-2 form-group"><label htmlFor="game-report-to">To</label><input id="game-report-to" type="date" className="form-control" value={toDate} min={fromDate} onChange={(e) => setToDate(e.target.value)} /></div>
              <div className="col-md-2 form-group"><label htmlFor="game-report-type">Type</label><select id="game-report-type" className="form-control" value={type} onChange={(e) => setType(e.target.value)}><option value="ALL">All</option><option value="MATCH_ODDS">Match</option><option value="FANCY">Fancy</option></select></div>
              <div className="col-md-6 report-button-column"><button type="button" className="btn btn-diamond" disabled={loading} onClick={() => requestReport("GAME_LIST")}>Game List</button></div>
              <div className="col-md-6 form-group"><label htmlFor="game-report-event">Game</label><select id="game-report-event" className="form-control" value={event} onChange={(e) => setEvent(e.target.value)}><option value="ALL">All</option>{events.map((item, index) => <option key={item.eventId || item.id || index} value={item.eventId || item.id}>{item.eventName || item.name}</option>)}</select></div>
              <div className="col-md-6 report-inline-actions"><button type="button" className="btn btn-diamond" disabled={loading} onClick={() => requestReport("GAME_REPORT")}>Show Game Report</button><button type="button" className="btn btn-diamond" disabled={loading} onClick={() => requestReport("MASTER_GAME_REPORT")}>Master Game Report</button></div>
            </div></div>
          </div>
          <div className="table-responsive data-table"><table className="table table-bordered clean-report-table"><thead><tr><th>Sr. No.</th><th>Name</th><th className="number-column">Amount</th></tr></thead><tbody>{rows.length ? rows.map((row, index) => <tr key={row.id || row.userName || index}><td>{index + 1}</td><td>{row.name || row.userName || row.eventName || "-"}</td><td className="number-column">{row.amount ?? row.profitLoss ?? 0}</td></tr>) : <tr><td colSpan={3} className="dataTables_empty">{loading ? "Loading report..." : "No data available in table"}</td></tr>}</tbody></table></div>
        </div>
      </div></div></div>
    </div>
  );
}
